export default __webpack_public_path__ + "static/media/Tess_Gompper_Resume_2022_08.695f7c8b.pdf";